/**
 * invoiceService.js
 * API calls for Invoice Management — uses the shared apiClient.
 */
import apiClient from './apiClient';

const BASE = '/admin/invoices';

/** List invoices with optional filters */
export async function fetchInvoices({ page = 1, limit = 20, status, search, userId } = {}) {
  const params = new URLSearchParams({ page, limit });
  if (status) params.set('status', status);
  if (search) params.set('search', search);
  if (userId) params.set('userId', userId);
  const { data } = await apiClient.get(`${BASE}?${params}`);
  return data.data;
}

/** Fetch a single invoice by ID */
export async function fetchInvoice(id) {
  const { data } = await apiClient.get(`${BASE}/${id}`);
  return data.data;
}

/**
 * Create a new invoice
 * @param {{ userId, dueDate?, notes?, taxPercent?, items[] }} payload
 */
export async function createInvoice(payload) {
  const { data } = await apiClient.post(BASE, payload);
  return data.data;
}

/**
 * Update an invoice (status, items, notes, etc.)
 * @param {string} id
 * @param {{ status?, dueDate?, notes?, taxPercent?, items? }} payload
 */
export async function updateInvoice(id, payload) {
  const { data } = await apiClient.patch(`${BASE}/${id}`, payload);
  return data.data;
}

/** Delete an invoice */
export async function deleteInvoice(id) {
  const { data } = await apiClient.delete(`${BASE}/${id}`);
  return data.data;
}

/** Returns the URL to download the PDF (opens/downloads directly via anchor) */
export function getPdfUrl(id) {
  // apiClient baseURL is something like http://localhost:PORT/api/v1
  const base = apiClient.defaults.baseURL || '';
  return `${base}${BASE}/${id}/pdf`;
}
